export const environment = {
  production: false,
  baseUrl: 'https://mgmt-mock.echo.dtcs.eu/api',
  auth: {
    clientId: 'c9ff5eb3-6861-439f-a6e2-92220ff4a4ed',
    authority: 'https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921',
    redirectUri: 'https://echo.dtcs.local',
  },
};
